import { computed } from '@vue/composition-api';

export function useClientChecker() {
    return {
        clientIsToolbox: computed(() => window.location.href.indexOf('com.findernet.Toolbox') >= 0),

        clientIsBabel: computed(() => window.location.href.indexOf('com.findernet.Babel') >= 0),

        clientIsYesly: computed(() => window.location.href.indexOf('com.findernet.Yesly') >= 0),
        clientIsGoogleYesly: computed(() => window.location.href.indexOf('com.google.actions.yesly') >= 0),
        clientIsAlexaYesly: computed(() => window.location.href.indexOf('com.amazon.skills.yesly') >= 0),

        clientIsBliss: computed(() => window.location.href.indexOf('com.findernet.bliss') >= 0),
        clientIsBliss2: computed(() => window.location.href.indexOf('com.findernet.Bliss2') >= 0),
        clientIsGoogleBliss: computed(() => window.location.href.indexOf('com.google.actions.bliss') >= 0),
        clientIsAlexaBliss: computed(() => window.location.href.indexOf('com.amazon.skills.bliss') >= 0),

        clientIsAdmin: computed(() => window.location.href.indexOf('com.findernet.Admin') >= 0),

        clientIsYou: computed(() => window.location.href.indexOf('com.findernet.You') >= 0),
        clientIsIftttYou: computed(() => window.location.href.indexOf('com.ifttt.skills.you') >= 0),
        clientIsGoogleYou: computed(() => window.location.href.indexOf('com.google.actions.you') >= 0),
        clientIsAlexaYou: computed(() => window.location.href.indexOf('com.amazon.skills.you') >= 0),
    }
}
